/* eslint-disable import/prefer-default-export */

/**
 * Convert a string to boolean value
 * @param {String} str string to be converted
 */
export function stringToBoolean(str) {
  if (str === '1' || str === 'true') {
    return true;
  }
  if (str === '0' || str === 'false') {
    return false;
  }
  return str;
}
